import "./optimization.css";
import { useTranslation } from "react-i18next";
import MenuLink from "../Shared/MenuLink";
import useScrollWatcher from "../Shared/ScrollWatcher";
import ContactForm from "../Shared/ContactForm";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ClientsMarquee from "./ClientsMarquee";

function Optimization() {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const [cards, setCards] = useState([]);
  const [advantagesRef, isAdvantagesVisible] = useScrollWatcher();
  const [choiceRef, isChoiceVisible] = useScrollWatcher();
  const [commerceRef, isCommerceVisible] = useScrollWatcher();
  const [tariffsRef, isTariffsVisible] = useScrollWatcher();

  const [advantages, setAdvantages] = useState([]);
  const advantagesUA = [
    {
      title: "Доданні вашого бізнесу на Google Maps",
      text: "Зробіть перший крок до залучення нових клієнтів, додавши свій бізнес на Google Maps! Ми допоможемо вам створити або оптимізувати профіль компанії, щоб ви були помітними для локальних користувачів. Точна інформація, правильні ключові слова та фото зроблять ваш бізнес легко знайденим.",
    },
    {
      title: "Органічному просуванню існуючих точок в Google карті",
      text: "Будьте першими, кого побачать клієнти, шукаючи ваші послуги в Google Maps! Ми оптимізуємо ваш бізнес-профіль, покращуємо видимість, опрацьовуємо відгуки та пишемо новини. Професійне налаштування, актуальні дані, позитивні відгуки — усе, щоб ваш бізнес завжди був на вершині результатів пошуку.",
    },
    {
      title: "Запуском платної реклами на картах (PPC)",
      text: "Забезпечте своєму бізнесу лідируючі позиції на Google Maps за допомогою платної реклами. Ми налаштуємо рекламну кампанію, щоб ваша локація з'являлася на перших рядках пошуку та привертала максимум уваги. Оптимізація бюджету, таргетинг на потрібну аудиторію й повний контроль результатів — усе, щоб ваш бізнес був першим вибором клієнтів.",
    },
    {
      title: "Піднятті репутації локальних точок",
      text: "Ми допоможемо вам збільшити кількість відгуків, опрацьовуємо наявні відгуки та спонукатимемо клієнтів залишати позитивні коментарі. Допомагаємо покращити репутацію вашого локального бізнесу в короткі терміни.",
    },
  ];
  const advantagesEN = [
    {
      title: "Adding your business to Google Maps",
      text: "Take the first step towards attracting new customers by adding your business to Google Maps! We will help you create or optimize your company profile so you are visible to local users. Accurate information, the right keywords, and photos will make your business easy to find.",
    },
    {
      title: "Organic promotion of existing locations on Google Maps",
      text: "Be the first clients see when searching for your services on Google Maps! We optimize your business profile, improve visibility, manage reviews, and write updates. Professional setup, up-to-date data, and positive reviews – everything to keep your business at the top of search results.",
    },
    {
      title: "Launching paid advertising on maps (PPC)",
      text: "Ensure your business ranks at the top of Google Maps with paid advertising. We will set up an ad campaign so your location appears in the top search results and attracts maximum attention. Budget optimization, targeted audience reach, and full result control – everything to make your business the first choice for customers.",
    },
    {
      title: "Improving the reputation of local locations",
      text: "We will help you increase the number of reviews, manage existing ones, and encourage clients to leave positive comments. We assist in improving your local business reputation in a short time.",
    },
  ];
  const advantagesES = [
    {
      title: "Agregar tu negocio a Google Maps",
      text: "¡Da el primer paso para atraer nuevos clientes agregando tu negocio a Google Maps! Te ayudamos a crear u optimizar el perfil de tu empresa para que seas visible para los usuarios locales. Información precisa, las palabras clave correctas y fotos harán que tu negocio sea fácil de encontrar.",
    },
    {
      title: "Promoción orgánica de ubicaciones existentes en Google Maps",
      text: "¡Sé el primero que vean los clientes cuando busquen tus servicios en Google Maps! Optimizamos tu perfil de negocio, mejoramos la visibilidad, gestionamos reseñas y publicamos novedades. Configuración profesional, datos actualizados y reseñas positivas: todo para que tu negocio esté siempre en la cima de los resultados de búsqueda.",
    },
    {
      title: "Lanzamiento de publicidad paga en mapas (PPC)",
      text: "Asegura que tu negocio ocupe las primeras posiciones en Google Maps con publicidad paga. Configuramos una campaña publicitaria para que tu ubicación aparezca en los primeros resultados de búsqueda y atraiga la máxima atención. Optimización del presupuesto, segmentación de la audiencia adecuada y control total de los resultados: todo para que tu negocio sea la primera elección de los clientes.",
    },
    {
      title: "Mejorar la reputación de ubicaciones locales",
      text: "Te ayudamos a aumentar la cantidad de reseñas, gestionar las existentes y motivar a los clientes a dejar comentarios positivos. Ayudamos a mejorar la reputación de tu negocio local en poco tiempo.",
    },
  ];
  const advantagesPL = [
    {
      title: "Dodanie Twojej firmy do Google Maps",
      text: "Zrób pierwszy krok w kierunku przyciągnięcia nowych klientów, dodając swoją firmę do Google Maps! Pomożemy Ci utworzyć lub zoptymalizować profil firmy, abyś był widoczny dla lokalnych użytkowników. Dokładne informacje, odpowiednie słowa kluczowe i zdjęcia sprawią, że Twoja firma będzie łatwa do znalezienia.",
    },
    {
      title: "Organiczna promocja istniejących lokalizacji w Google Maps",
      text: "Bądź pierwszym, którego klienci zobaczą podczas wyszukiwania Twoich usług na Google Maps! Optymalizujemy profil Twojej firmy, poprawiamy widoczność, zarządzamy opiniami i piszemy aktualizacje. Profesjonalna konfiguracja, aktualne dane i pozytywne opinie – wszystko, aby utrzymać Twoją firmę na szczycie wyników wyszukiwania.",
    },
    {
      title: "Uruchamianie płatnej reklamy na mapach (PPC)",
      text: "Zapewnij swojej firmie miejsce na szczycie Google Maps dzięki płatnej reklamie. Skonfigurujemy kampanię reklamową, aby Twoja lokalizacja pojawiała się w najwyższych wynikach wyszukiwania i przyciągała maksymalną uwagę. Optymalizacja budżetu, dotarcie do docelowej grupy odbiorców i pełna kontrola nad wynikami – wszystko, aby Twoja firma była pierwszym wyborem klientów.",
    },
    {
      title: "Poprawa reputacji lokalnych lokalizacji",
      text: "Pomożemy Ci zwiększyć liczbę opinii, zarządzać istniejącymi i zachęcać klientów do pozostawiania pozytywnych komentarzy. Wspieramy szybkie poprawianie reputacji Twojej lokalnej firmy.",
    },
  ];

  const [choices, setChoices] = useState([]);
  const choicesUA = [
    {
      title: "Оптимізація для легкого знаходження",
      description:
        "Ми ідеально оптимізуємо карточку вашої організації в Google My Business, що дозволить легко знайти ваш бізнес на Google Maps, навіть коли користувачі в русі.",
    },
    {
      title: "Відгуки та рейтинги",
      description:
        "Допомагаємо вам збирати та виводити позитивні відгуки, підвищуючи рейтинг вашого бізнесу та покращуючи його репутацію.",
    },
    {
      title: "Моніторинг та звітність",
      description:
        "Наші інструменти моніторингу та звітності дозволяють вам стежити за взаємодією користувачів з вашим бізнесом на карті.",
    },
  ];
  const choicesEN = [
    {
      title: "Optimization for easy discovery",
      description:
        "We perfectly optimize your Google My Business profile, making it easy for users to find your business on Google Maps, even while on the move.",
    },
    {
      title: "Reviews and ratings",
      description:
        "We help you collect and showcase positive reviews, increasing your business rating and improving its reputation.",
    },
    {
      title: "Monitoring and reporting",
      description:
        "Our monitoring and reporting tools allow you to track user interactions with your business on the map.",
    },
  ];
  const choicesES = [
    {
      title: "Optimización para un fácil descubrimiento",
      description:
        "Optimizamos perfectamente el perfil de tu negocio en Google My Business, facilitando que los usuarios encuentren tu empresa en Google Maps, incluso mientras están en movimiento.",
    },
    {
      title: "Reseñas y calificaciones",
      description:
        "Te ayudamos a recopilar y mostrar reseñas positivas, aumentando la calificación de tu negocio y mejorando su reputación.",
    },
    {
      title: "Monitoreo e informes",
      description:
        "Nuestras herramientas de monitoreo e informes te permiten rastrear la interacción de los usuarios con tu negocio en el mapa.",
    },
  ];
  const choicesPL = [
    {
      title: "Optymalizacja dla łatwego odnajdywania",
      description:
        "Perfekcyjnie optymalizujemy Twój profil Google My Business, dzięki czemu użytkownicy łatwo znajdą Twoją firmę na Google Maps, nawet będąc w ruchu.",
    },
    {
      title: "Opinie i oceny",
      description:
        "Pomagamy zbierać i prezentować pozytywne opinie, zwiększając ocenę Twojej firmy i poprawiając jej reputację.",
    },
    {
      title: "Monitoring i raportowanie",
      description:
        "Nasze narzędzia do monitoringu i raportowania pozwalają śledzić interakcje użytkowników z Twoją firmą na mapie.",
    },
  ];

  const navigate = useNavigate();
  const tariffsBody = (
    <div className="tariffs__body tariffs__body-ua grid-optim">
      {/*<div className="tariffs__item item-tariffs item-tariffs--basic">*/}
      {/*  <div className={"item-tariffs__bonus-cover"}></div>*/}
      {/*  <div className={"item-tariffs__bonus"}>*/}
      {/*    <p>{t("seo.package.guarantee")} 10%</p>*/}
      {/*  </div>*/}
      {/*  <div className="item-tariffs__head" style={{ height: "130px" }}>*/}
      {/*    <div className="item-tariffs__block">*/}
      {/*      <p className="item-tariffs__price">*/}
      {/*        <span>{t("seo.package.sum1")}</span> {t("seo.package.currency")}*/}
      {/*      </p>*/}
      {/*      <p className="item-tariffs__text">{t("seo.package.once")}</p>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*  <div className="item-tariffs__body">*/}
      {/*    <div className="item-tariffs__subtitle">*/}
      {/*      {t("seo.whatIsIncludedInPackage")}*/}
      {/*    </div>*/}
      {/*    <ul className="item-tariffs__list">*/}
      {/*      <li className="item-tariffs__li">{t("seo.completeProfile100")}</li>*/}
      {/*      <li className="item-tariffs__li">{t("seo.workWithPhotos")}</li>*/}
      {/*      <li className="item-tariffs__li">{t("seo.errorCorrection")}</li>*/}
      {/*      <li className="item-tariffs__li">{t("seo.profileCheck")}</li>*/}
      {/*      <li className="item-tariffs__li">{t("seo.removeThirdParty")}</li>*/}
      {/*      <li className="item-tariffs__li item-tariffs__li--disabled">*/}
      {/*        {t("seo.strategyDevelopment")}*/}
      {/*      </li>*/}
      {/*      <li className="item-tariffs__li item-tariffs__li--disabled">*/}
      {/*        {t("seo.keywordSelection")}*/}
      {/*      </li>*/}
      {/*      <li className="item-tariffs__li item-tariffs__li--disabled">*/}
      {/*        {t("seo.activitySupport")}*/}
      {/*      </li>*/}
      {/*      <li className="item-tariffs__li item-tariffs__li--disabled">*/}
      {/*        {t("seo.advancedReporting")}*/}
      {/*      </li>*/}
      {/*    </ul>*/}
      {/*    <div className="item-tariffs__note">*/}
      {/*      {t("seo.packageCustomizable")}*/}
      {/*    </div>*/}
      {/*    <MenuLink*/}
      {/*      className="item-tariffs__btn button"*/}
      {/*      text={t("seo.select")}*/}
      {/*      targetId={"contacts"}*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*</div>*/}
      <div className="tariffs__item item-tariffs item-tariffs--basic">
        <div className={"item-tariffs__bonus-cover"}></div>
        <div className={"item-tariffs__bonus"}>
          <p>{t("seo.package.guarantee")} 10%</p>
        </div>
        <div className="item-tariffs__head" style={{ height: "130px" }}>
          <div className="item-tariffs__block">
            <p className="item-tariffs__price">
              <span>{t("seo.package.sum1")}</span> {t("seo.package.currency")}/
              {t("seo.package.month")}
            </p>
            <p className="item-tariffs__text">
              {Math.round((t("seo.package.sum1") * 3)/10) * 10} {t("seo.package.currency")}/3{" "}
              {t("seo.package.months")}
            </p>
            {/*{i18n.language === "pl" && (*/}
            {/*  <p*/}
            {/*    className="item-tariffs__text"*/}
            {/*    style={{ fontSize: 14, marginTop: -10 }}*/}
            {/*  >*/}
            {/*    Nie zawierają VAT*/}
            {/*  </p>*/}
            {/*)}*/}
            {/*<p className="item-tariffs__text">*/}
            {/*  {t("seo.package.sum2")} {t("seo.package.currency")}/1{" "}*/}
            {/*  {t("seo.package.month")}*/}
            {/*</p>*/}
          </div>
        </div>
        <div className="item-tariffs__body">
          <div className="item-tariffs__subtitle">
            {t("seo.whatIsIncludedInPackage")}
          </div>
          <ul className="item-tariffs__list">
            <li className="item-tariffs__li">{t("seo.completeProfile100")}</li>
            <li className="item-tariffs__li">{t("seo.workWithPhotos")}</li>
            <li className="item-tariffs__li">{t("seo.errorCorrection")}</li>
            <li className="item-tariffs__li">{t("seo.profileCheck")}</li>
            <li className="item-tariffs__li">{t("seo.removeThirdParty")}</li>
            <li className="item-tariffs__li">{t("seo.strategyDevelopment")}</li>
            <li className="item-tariffs__li">{t("seo.keywordSelection")}</li>
            <li className="item-tariffs__li">{t("seo.activitySupport")}</li>
            <li className="item-tariffs__li">{t("seo.advancedReporting")}</li>
          </ul>
          <div className="item-tariffs__note">
            {t("seo.packageCustomizable")}
          </div>
          <MenuLink
            className="item-tariffs__btn button"
            text={t("seo.select")}
            targetId={"contacts"}
          />
        </div>
      </div>
      <div className="tariffs__item item-tariffs item-tariffs--popular">
        <div className={"item-tariffs__bonus-cover"}></div>
        <div className={"item-tariffs__bonus"}>
          <p>{t("seo.package.guarantee")} 25%</p>
        </div>
        <div className="item-tariffs__head" style={{ height: "130px" }}>
          <div className="item-tariffs__block">
            <p className="item-tariffs__price">
              <span>{t("seo.package.sum2")}</span> {t("seo.package.currency")}/
              {t("seo.package.month")}
            </p>
            <p className="item-tariffs__text ">
              {Math.round((t("seo.package.sum2") * 6) / 10) * 10} {t("seo.package.currency")}/6{" "}
              {t("seo.package.manyMonths")}
            </p>
            <p
                className="item-tariffs__text plazhka"
            >
              <img src={"/img/icons/star-icon.svg"} alt={"Popular"}></img>
              <span>Найпопулярніший</span>
            </p>
            {/*{i18n.language === "pl" && (*/}
            {/*  <p*/}
            {/*    className="item-tariffs__text"*/}
            {/*    style={{ fontSize: 14, marginTop: -13 }}*/}
            {/*  >*/}
            {/*    Nie zawierają VAT*/}
            {/*  </p>*/}
            {/*)}*/}
          </div>
        </div>
        <div className="item-tariffs__body">
          <div className="item-tariffs__subtitle">
            {t("seo.whatIsIncludedInPackage")}
          </div>
          <ul className="item-tariffs__list">
            <li className="item-tariffs__li">{t("seo.completeProfile100")}</li>
            <li className="item-tariffs__li">{t("seo.workWithPhotos")}</li>
            <li className="item-tariffs__li">{t("seo.errorCorrection")}</li>
            <li className="item-tariffs__li">{t("seo.profileCheck")}</li>
            <li className="item-tariffs__li">{t("seo.removeThirdParty")}</li>
            <li className="item-tariffs__li">{t("seo.strategyDevelopment")}</li>
            <li className="item-tariffs__li">{t("seo.keywordSelection")}</li>
            <li className="item-tariffs__li">{t("seo.activitySupport")}</li>
            <li className="item-tariffs__li">{t("seo.advancedReporting")}</li>
          </ul>
          <div className="item-tariffs__note">
            {t("seo.packageCustomizable")}
          </div>
          <MenuLink
            className="item-tariffs__btn button"
            text={t("seo.select")}
            targetId={"contacts"}
          />
        </div>
      </div>
      <div className="tariffs__item item-tariffs item-tariffs--professional">
        <div className={"item-tariffs__bonus-cover"}></div>
        <div className={"item-tariffs__bonus"}>
          <p>{t("seo.package.guarantee")} 60%</p>
        </div>
        <div className="item-tariffs__head" style={{ height: "130px" }}>
          <div className="item-tariffs__block">
            <p className="item-tariffs__price">
              <span>{t("seo.package.sum4")}</span> {t("seo.package.currency")}/
              {t("seo.package.month")}
            </p>
            <p className="item-tariffs__text">
              {Math.round((t("seo.package.sum4") * 12) / 10) * 10} {t("seo.package.currency")}/12{" "}
              {t("seo.package.manyMonths")}
            </p>
                <p
                  className="item-tariffs__text plazhka"
                >
                  <img src={"/img/icons/flames-icon.svg"} alt={"Popular"}></img>
                  <span>Найвигідніший</span>
                </p>

          </div>
        </div>
        <div className="item-tariffs__body">
          <div className="item-tariffs__subtitle">
            {t("seo.whatIsIncludedInPackage")}
          </div>
          <ul className="item-tariffs__list">
            <li className="item-tariffs__li">{t("seo.completeProfile100")}</li>
            <li className="item-tariffs__li">{t("seo.workWithPhotos")}</li>
            <li className="item-tariffs__li">{t("seo.errorCorrection")}</li>
            <li className="item-tariffs__li">{t("seo.profileCheck")}</li>
            <li className="item-tariffs__li">{t("seo.removeThirdParty")}</li>
            <li className="item-tariffs__li">{t("seo.strategyDevelopment")}</li>
            <li className="item-tariffs__li">{t("seo.keywordSelection")}</li>
            <li className="item-tariffs__li">{t("seo.activitySupport")}</li>
            <li className="item-tariffs__li">{t("seo.advancedReporting")}</li>
          </ul>
          <div className="item-tariffs__note">
            {t("seo.packageCustomizable")}
          </div>
          <MenuLink
            className="item-tariffs__btn button"
            text={t("seo.select")}
            targetId={"contacts"}
          />
        </div>
      </div>
      {/*<div className="tariffs__item item-tariffs item-tariffs--professional">*/}
      {/*  <div className="item-tariffs__head" style={{ height: "130px" }}>*/}
      {/*    <div className="item-tariffs__block">*/}
      {/*      <p className="item-tariffs__price">*/}
      {/*        <span>{t("seo.package.sum3")}</span> {t("seo.package.currency")}/*/}
      {/*        {t("seo.package.month")}*/}
      {/*      </p>*/}
      {/*      <p className="item-tariffs__text">*/}
      {/*        {t("seo.package.sum3") * 12} {t("seo.package.currency")}/12{" "}*/}
      {/*        {t("seo.package.months")}*/}
      {/*      </p>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*  <div className="item-tariffs__body">*/}
      {/*    <div className="item-tariffs__subtitle">*/}
      {/*      {t("seo.whatIsIncludedInPackage")}*/}
      {/*    </div>*/}
      {/*    <ul className="item-tariffs__list">*/}
      {/*      <li className="item-tariffs__li">{t("seo.strategyDevelopment")}</li>*/}
      {/*      <li className="item-tariffs__li">{t("seo.completeProfile100")}</li>*/}
      {/*      <li className="item-tariffs__li">{t("seo.keywordSelection")}</li>*/}
      {/*      <li className="item-tariffs__li">{t("seo.workWithPhotos")}</li>*/}
      {/*      <li className="item-tariffs__li">{t("seo.errorCorrection")}</li>*/}
      {/*      <li className="item-tariffs__li">{t("seo.activitySupport")}</li>*/}
      {/*      <li className="item-tariffs__li">{t("seo.profileCheck")}</li>*/}
      {/*      <li className="item-tariffs__li">{t("seo.advancedReporting")}</li>*/}
      {/*    </ul>*/}
      {/*    <div className="item-tariffs__note">*/}
      {/*      {t("seo.packageCustomizable")}*/}
      {/*    </div>*/}
      {/*    <MenuLink*/}
      {/*      className="item-tariffs__btn button"*/}
      {/*      text={t("seo.select")}*/}
      {/*      targetId={"contacts"}*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>
  );
  useEffect(() => {
    const advantagesMap = {
      es: advantagesES,
      en: advantagesEN,
      ua: advantagesUA,
      pl: advantagesPL,
    };

    const choicesMap = {
      es: choicesES,
      en: choicesEN,
      ua: choicesUA,
      pl: choicesPL,
    };

    const lang = i18n.language || "ua";

    setAdvantages(advantagesMap[lang] || advantagesMap.ua);
    setChoices(choicesMap[lang] || choicesMap.ua);

    fetch("/posts.json")
      .then((response) => response.json())
      .then((data) => setCards(data))
      .catch((error) => console.error("Error fetching data:", error));
  }, [i18n.language]);

  return (
    <main className="promoting">
      <section className={"promoting__container"}>
        <div className={"optimization-container"}>
          <p className={"title"}>
            <p className="title-gradient title-center-sm">
              {t("seo.promotionOnGoogleMaps")}
            </p>
            <p className="title title-center-sm">{t("seo.withResult")}</p>
          </p>
          <div className="optimization-photo opt-photo-sm">
            <img src={"./img/optimization/frame-175.png"} alt="" />
          </div>
          <p>{t("seo.businessVisibility")}</p>
          <div className="benefits tick">
            <p> {t("seo.clearStrategy")}</p>
            <p> {t("seo.transparentReporting")}</p>
            <p> {t("seo.preliminaryAnalysis")}</p>
            <p> {t("seo.teamOfExperts")}</p>
          </div>
          <MenuLink
            targetId={"contacts"}
            text={t("seo.submitRequest")}
            className="header__btn button request-button"
            disableRouting={true}
          />
        </div>
        <div className="optimization-photo">
          <img src={"./img/optimization/frame-175.png"} alt="" />
        </div>
      </section>
      {i18n.language === "ua" && (
        <section>
          <div className={"marquee__container"}>
            <h1 className={"title title-center"}>{t("seo.ourClients")}</h1>
            <ClientsMarquee />
          </div>
        </section>
      )}
      <section
        data-watch
        data-watch-threshold="0.5"
        ref={advantagesRef}
        className={
          isAdvantagesVisible ? "advantages _watcher-view" : "advantages"
        }
      >
        <div className={"comforts__container"}>
          <p className={"title title-center"}>{t("seo.canHelpWith")}</p>
          <div className={"benefits-container"}>
            {advantages.map((slide, index) => (
              <div className={"advantage"} key={index}>
                <div className="advantages-item" style={{ height: "100%" }}>
                  <div className="advantages-item__head">
                    <div className="advantages-item__num">{index + 1}</div>
                    <h3 className="advantages-item__title">{slide.title}</h3>
                  </div>
                  <div className="advantages-item__text">{slide.text}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section
        data-watch
        data-watch-threshold="0.5"
        ref={choiceRef}
        className={isChoiceVisible ? "choice _watcher-view" : "choice"}
      >
        <div className={"choice__container"}>
          <p className={"title choice__title title-center"}>
            {" "}
            {t("seo.whyChooseUs")}
          </p>
          <div className={"choices"}>
            {choices.map((choice, index) => (
              <div className={"choice-item"} key={index}>
                <p className={"item-num"}>0{index + 1}</p>
                <div
                  style={{
                    height: "90px",
                    marginBottom: "10px",
                  }}
                >
                  <p className={"choice-item_title"}>{choice.title}</p>
                </div>
                <p className={"choice-item_desc"}>{choice.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section
        data-watch
        data-watch-threshold="0.15"
        ref={tariffsRef}
        className={isTariffsVisible ? "tariffs _watcher-view" : "tariffs"}
        id="tariffsTop"
      >
        <div className="tariffs__container">
          <div className="tariffs__head">
            <h4 className="tariffs__subtitle subtitle title-center">
              {t("seo.choose")}
            </h4>
            <h2 className="tariffs__title title title-center">
              {t("seo.whichTariff")}
            </h2>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {tariffsBody}
          </div>
        </div>
      </section>

      <section
        data-watch
        data-watch-threshold="0.5"
        ref={commerceRef}
        className={isCommerceVisible ? "commerce _watcher-view" : "commerce"}
      >
        <div className={"commerce__container"}>
          <div className={"commerce-col"}>
            <p className={"title title-center-sm"}>
              {t("seo.getProposal")}
              <p className={"title-gradient"}>{t("seo.rightNow")}</p>
            </p>
            <div className={"commerce_text tick"}>
              <p>{t("seo.auditLocation")}</p>
              <p>{t("seo.reviewCompetitors")}</p>
              <p>{t("seo.optimalActionPlan")}</p>
              <p>{t("seo.calculateVolumeAndCost")}</p>
            </div>
            <MenuLink
              targetId={"contacts"}
              text={t("seo.wantDetails")}
              className="header__btn button request-button"
              disableRouting={true}
            />
          </div>
          <div className={"commerce-col col-right"}>
            <div className="circle-wrapper">
              <img
                src="img/promo-robot.png"
                alt="Image"
                className="robot-image"
              />
              <div className="half-circle"></div>
            </div>
          </div>
        </div>
      </section>
      <section className={"m-0-sm"}>
        <div className={"promotion__container"}>
          <p className={"title title-center"}>{t("seo.promotionServices")}</p>
          <div className="promotion-action">
            <div className={"promotion-col col-form"}>
              <div className="simple-form">
                <ContactForm isSingle={true} country={i18n.language} />
              </div>
            </div>
            <div className={"promotion-col"}>
              <p>
                <strong>{t("seo.promotionOnGoogleMapsByScout")}</strong>
              </p>
              <p>{t("seo.googleMapsDescription")}</p>
              <p>{t("seo.googleMapsForLocalBusiness")}</p>
              <p>
                <strong>{t("seo.googleMapsPotential")}</strong>
              </p>
              <p>{t("seo.googleMyBusinessNeglected")}</p>
              <p>{t("seo.googleMapsPotentialForBusiness")}</p>
              <p>
                <strong>{t("seo.googleMapsPromotionMethods")}</strong>
              </p>
              <p>
                <ol>
                  <li>{t("seo.googleMapsPromotionMethodsList.0")}</li>
                  <li>{t("seo.googleMapsPromotionMethodsList.1")}</li>
                  <li>{t("seo.googleMapsPromotionMethodsList.2")}</li>
                  <li>{t("seo.googleMapsPromotionMethodsList.3")}</li>
                  <li>{t("seo.googleMapsPromotionMethodsList.4")}</li>
                  <li>{t("seo.googleMapsPromotionMethodsList.5")}</li>
                </ol>
              </p>
              <p>
                <strong>{t("seo.googleMapsPromotionBenefits")}</strong>
              </p>
              <p>{t("seo.googleMapsPromotionExplanation")}</p>
              <p>{t("seo.googleMapsPromotionSearchResults")}</p>
              <p>{t("seo.googleMapsPromotionBenefit")}</p>
              <p>
                <ol>
                  <li>{t("seo.googleMapsAttention")}</li>
                  <li>{t("seo.googleMapsVisibility")}</li>
                  <li>{t("seo.googleMapsImage")}</li>
                  <li>{t("seo.googleMapsReputation")}</li>
                  <li>{t("seo.googleMapsLoyalty")}</li>
                  <li>{t("seo.googleMapsCommunication")}</li>
                  <li>{t("seo.googleMapsTraffic")}</li>
                  <li>{t("seo.googleMapsAttentionTravelers")}</li>
                </ol>
              </p>
              <p>
                <strong>{t("seo.howPromotionWorks")}</strong>
              </p>
              <p>{t("seo.googleMapsAdditionalFeature")}</p>
              <div className={"tick"}>
                <p>{t("seo.clientAttractionNearby")}</p>
                <p>{t("seo.organizationInfoPlacement")}</p>
              </div>
              <p>{t("seo.localSearchAds")}</p>
              <p>{t("seo.setUpSearchAds")}</p>
              <p>
                <ol>
                  <li>{t("seo.selectGoal")}</li>
                  <li>{t("seo.setGoalsAndBudget")}</li>
                  <li>{t("seo.addAddress")}</li>
                  <li>{t("seo.confirmAction")}</li>
                </ol>
              </p>
              <p> {t("seo.adClickTypes")}</p>
              <div className={"tick"}>
                <p>{t("seo.getLocationInfo")}</p>
                <p>{t("seo.getDirections")}</p>
                <p>{t("seo.mobileAdsWithPhoneNumber")}</p>
                <p>{t("seo.siteOrSocialMediaLinks")}</p>
              </div>
              <p>{t("seo.howToAnalyzeResults")}</p>
              <p>{t("seo.campaignNavigation")}</p>
              <p>{t("seo.updateProfileData")}</p>
              <p>{t("seo.addPhotos")}</p>
              <div className="tick">
                <p>{t("seo.imageFormat")}</p>
                <p>{t("seo.imageSize")}</p>
                <p>{t("seo.imageResolution")}</p>
                <p>{t("seo.imageClarity")}</p>
                <p>{t("seo.imageAccuracy")}</p>
              </div>
              <p>{t("seo.respondToReviews")}</p>
              <p>
                <strong>{t("seo.whyChooseScout")}</strong>
              </p>
              <p>{t("seo.promoteWithScout")}</p>
              <p>{t("seo.increasePresence")}</p>
              <p>{t("seo.fullService")}</p>
              <p>{t("seo.contactManager")}</p>
            </div>
          </div>
        </div>
      </section>
      {i18n.language === "ua" ? (
        <section data-watch="" data-watch-threshold="0.5">
          <div className="blog-optim__container">
            <div className="services__head cusstom">
              <h4 className="services__subtitle subtitle">НАШ БЛОГ</h4>
              <h2 className="services__title title">
                ВАМ ТАКОЖ МОЖЕ БУТИ ЦІКАВО
              </h2>
            </div>
            <div className="services__body">
              <Swiper
                spaceBetween={50}
                breakpoints={{
                  653: {
                    slidesPerView: 2,
                  },
                  1000: {
                    slidesPerView: 3,
                  },
                  1390: {
                    slidesPerView: 4,
                  },
                }}
                navigation={{
                  nextEl: ".serv-swiper-button-next",
                  prevEl: ".serv-swiper-button-prev",
                }}
                pagination={{ clickable: true }}
                modules={[Navigation, Pagination]}
                className="services__slider"
              >
                {cards.map((post, index) => (
                  <SwiperSlide
                    key={index}
                    onClick={() => navigate(`/blog/${post.id}`)}
                    className="item-services swiper-slide blog-card-custom"
                  >
                    <div
                      className="item-services__img"
                      style={{ transform: "rotate(0)" }}
                    >
                      <img
                        src={`/img/blog/${post.image}`}
                        alt={post.title}
                        style={{ maxHeight: "400px", aspectRatio: "1" }}
                      />
                    </div>
                    <h4
                      className="item-services__title"
                      style={{ marginTop: "-7.5rem" }}
                    >
                      <span className={"blog__card-title_optim"}>
                        {post.title}
                      </span>
                    </h4>
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="services__navigation">
                <button type="button" className="serv-swiper-button-prev">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M5.24408 9.41074C4.91864 9.73618 4.91864 10.2638 5.24408 10.5893L11.9107 17.2559C12.2362 17.5814 12.7638 17.5814 13.0893 17.2559C13.4147 16.9305 13.4147 16.4028 13.0893 16.0774L7.01184 10L13.0893 3.92259C13.4147 3.59715 13.4147 3.06951 13.0893 2.74408C12.7638 2.41864 12.2362 2.41864 11.9107 2.74408L5.24408 9.41074Z"
                      fill="#C4D0E4"
                    />
                  </svg>
                </button>
                <button type="button" className="serv-swiper-button-next">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14.7559 9.41074C15.0814 9.73618 15.0814 10.2638 14.7559 10.5893L8.08926 17.2559C7.76382 17.5814 7.23618 17.5814 6.91075 17.2559C6.58531 16.9305 6.58531 16.4028 6.91075 16.0774L12.9882 10L6.91074 3.92259C6.58531 3.59715 6.58531 3.06951 6.91074 2.74408C7.23618 2.41864 7.76382 2.41864 8.08926 2.74408L14.7559 9.41074Z"
                      fill="#C4D0E4"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </section>
      ) : (
        ""
      )}
      <ContactForm country={i18n.language} />
    </main>
  );
}

export default Optimization;
